package utils

import com.soywiz.korim.font.*
import com.soywiz.korio.file.std.*

object FontsLoader {

    const val RUBIK_SPRAY_PAINT_REGULAR = "RubikSprayPaint-Regular.ttf"
    const val RUSSO_ONE_REGULAR = "RussoOne-Regular.ttf"
    const val GOGONO_COCOA_MOCHI_CYRILLIC = "gogono-cocoa-mochi-cyrillic.otf"

    suspend fun loadFont(fontPath: String): TtfFont {
        return resourcesVfs["fonts/$fontPath"].readTtfFont()
    }
}
